<img src="assets/logo_expert.svg" alt="Logo Tiime Expert" />
&nbsp;
<span class="d">.</span>
<span class="d d-2">.</span>
<span class="d d-3">.</span>
